import { useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { sendContact } from '../api/client.js';
import { BRAND, PROP_TYPES, ZONAS } from '../data/constants.js';

const STEPS = ['¿Qué querés hacer?','Tu propiedad','Ubicación','Características','Tus datos'];

export default function Sell() {
  const [sp] = useSearchParams();
  const isTasacion = sp.get('modo') === 'tasacion';
  const [step, setStep] = useState(0);
  const [d, setD]       = useState({ op: isTasacion?'tasar':'vender', tipo:'', zona:'', calle:'', amb:'', sup:'', estado:'', nombre:'', contacto:'', comentarios:'', consent:false });
  const [done, setDone] = useState(false);
  const [loading, setLoading] = useState(false);
  const upd = (k,v) => setD(s=>({...s,[k]:v}));
  const pct = Math.round(((step+1)/STEPS.length)*100);

  const canNext = () => { if(step===1) return !!d.tipo; if(step===2) return !!d.zona; if(step===4) return d.nombre.trim() && d.contacto.trim() && d.consent; return true; };

  const submit = async () => {
    if (!canNext()) return;
    setLoading(true);
    try {
      await sendContact({ name:d.nombre, phone:d.contacto, email:d.contacto, message:`Tipo: ${d.tipo} | Zona: ${d.zona} ${d.calle} | Ambientes: ${d.amb} | Sup: ${d.sup}m² | Estado: ${d.estado} | Operación: ${d.op} | ${d.comentarios}` });
      setDone(true);
    } catch(e) { alert(e.message); }
    finally { setLoading(false); }
  };

  const Pill = ({ k, v, label, sub }) => (
    <button className={"vstep-pill"+(d[k]===v?" on":"")} onClick={()=>upd(k,v)}>
      <b>{label}</b>{sub&&<span>{sub}</span>}
    </button>
  );

  if (done) return (
    <div className="container page vender-done">
      <div className="vd-ic">✓</div>
      <h1>{isTasacion?'¡Pedido de tasación recibido!':'¡Recibimos tu propiedad!'}</h1>
      <p>Un asesor de Abriola va a revisar los datos y se va a comunicar con vos en las próximas 24 a 48 horas.</p>
      <div className="vd-actions">
        <a className="btn btn-primary" href="/">Volver al inicio</a>
        <a className="btn btn-wa" href={`https://wa.me/${BRAND.waVentas}`} target="_blank" rel="noopener">💬 Escribir por WhatsApp</a>
      </div>
    </div>
  );

  return (
    <div className="container page vender">
      <div className="vender-grid">
        <div className="vender-left">
          <span className="kicker">{isTasacion?'Tasación gratuita':'Vender o alquilar'}</span>
          <h1 className="vender-h1">{isTasacion?'Sabé cuánto vale tu propiedad':'Publicá tu propiedad con Abriola'}</h1>
          <p className="vender-lead">{isTasacion?'Te damos un valor de referencia real, basado en operaciones de tu zona. Sin compromiso, en 24 a 48 horas.':'Fotos profesionales, difusión a compradores reales y acompañamiento hasta la firma.'}</p>
          <ul className="vender-bullets">
            {[['📷','Fotos profesionales sin costo'],['🛡','Asesoría legal y escrituración'],['📡','Difusión en portales y redes'],['👤','Un asesor dedicado a tu operación']].map(([ic,t])=>(
              <li key={t}><span>{ic}</span>{t}</li>
            ))}
          </ul>
        </div>
        <div className="vender-card">
          <div className="vstep-prog">
            <div className="vstep-bar"><div className="vstep-fill" style={{width:pct+'%'}}/></div>
            <span className="vstep-count">Paso {step+1} de {STEPS.length}</span>
          </div>
          <h3 className="vstep-title">{STEPS[step]}</h3>
          <div className="vstep-body">
            {step===0&&<div className="vstep-pills">
              <Pill k="op" v="vender" label="Vender" sub="Quiero vender mi propiedad" />
              <Pill k="op" v="alquilar" label="Alquilar" sub="Quiero ponerla en alquiler" />
              {isTasacion&&<Pill k="op" v="tasar" label="Solo tasar" sub="Saber el valor por ahora" />}
            </div>}
            {step===1&&<div className="vstep-pills grid2">{Object.entries(PROP_TYPES).map(([k,v])=><Pill key={k} k="tipo" v={k} label={v} />)}</div>}
            {step===2&&<div className="vstep-fields">
              <div className="field"><label>Zona / barrio</label><div className="fc-selwrap"><select className="select" value={d.zona} onChange={e=>upd('zona',e.target.value)}><option value="">Elegí la zona</option>{ZONAS.map(z=><option key={z.slug} value={z.name}>{z.name}</option>)}</select></div></div>
              <div className="field"><label>Calle y altura (opcional)</label><input className="input" value={d.calle} onChange={e=>upd('calle',e.target.value)} placeholder="Ej. Don Bosco 10" /></div>
            </div>}
            {step===3&&<div className="vstep-fields">
              <div className="fc-row">
                <div className="field"><label>Ambientes</label><input className="input" type="number" value={d.amb} onChange={e=>upd('amb',e.target.value)} placeholder="Ej. 3" /></div>
                <div className="field"><label>Superficie (m²)</label><input className="input" type="number" value={d.sup} onChange={e=>upd('sup',e.target.value)} placeholder="Ej. 78" /></div>
              </div>
              <div className="field"><label>Estado</label><div className="vstep-pills row"><Pill k="estado" v="excelente" label="Excelente" /><Pill k="estado" v="bueno" label="Bueno" /><Pill k="estado" v="reciclar" label="A reciclar" /></div></div>
            </div>}
            {step===4&&<div className="vstep-fields">
              <div className="field"><label>Nombre</label><input className="input" value={d.nombre} onChange={e=>upd('nombre',e.target.value)} placeholder="Tu nombre" /></div>
              <div className="field"><label>Teléfono o email</label><input className="input" value={d.contacto} onChange={e=>upd('contacto',e.target.value)} placeholder="+54 11 …" /></div>
              <div className="field"><label>Comentarios (opcional)</label><textarea className="input" rows={2} value={d.comentarios} onChange={e=>upd('comentarios',e.target.value)} placeholder="Contanos lo que quieras sobre la propiedad" /></div>
              <label className="cf-consent"><input type="checkbox" checked={d.consent} onChange={e=>upd('consent',e.target.checked)} /><span className="fc-box">{d.consent&&'✓'}</span><span>Acepto ser contactado por Abriola.</span></label>
            </div>}
          </div>
          <div className="vstep-nav">
            {step>0&&<button className="btn btn-ghost" onClick={()=>setStep(s=>s-1)}>← Atrás</button>}
            {step<STEPS.length-1
              ? <button className={"btn btn-primary"+(canNext()?'':' disabled')} disabled={!canNext()} onClick={()=>canNext()&&setStep(s=>s+1)}>Continuar →</button>
              : <button className={"btn btn-primary"+(canNext()?'':' disabled')} disabled={!canNext()||loading} onClick={submit}>{loading?'Enviando…':isTasacion?'Pedir tasación ✓':'Enviar propiedad ✓'}</button>}
          </div>
        </div>
      </div>
    </div>
  );
}
